import React from 'react';
import DepartmentWorkPlanner from '../../components/DepartmentWorkPlanner';

const OperationsWorkPlanner = () => {
  return <DepartmentWorkPlanner department="operations" departmentName="Operations Department" />;
};

export default OperationsWorkPlanner;
